import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvailabilityProduct } from '../../workflow/workflow.types';

@Component({
    selector: 'app-select-availability',
    templateUrl: './select-availability.component.html',
    standalone: false
})
export class SelectAvailablityComponent {
  @Input() public selectedAvailability: string;
  @Input() public availabilityLevels: AvailabilityProduct[] = [];

  @Output() public readonly standardSelected = new EventEmitter<string>();
  @Output() public readonly premiumSelected = new EventEmitter<string>();
  @Output() public readonly back = new EventEmitter<void>();

  private readonly PREMIUM_PRODUCT = "PC-ONE-PREMIUM"
  private readonly STANDARD_PRODUCT = "STANDARD"

  constructor() { 
  }

  onBack() { 
    this.back.emit();
  }

  public onStandardSelected() {
    this.standardSelected.emit();
  }

  public onPremiumSelected() {
    this.premiumSelected.emit();
  }

  get premiumLevel() {
    return this.availabilityLevels.find(l => l?.name === this.PREMIUM_PRODUCT);
  }

  get standardLevel() {
    return this.availabilityLevels.find(l => l?.name === this.STANDARD_PRODUCT);
  } 
}
